import { httpGET, json } from './utils';
import { ACTIONS } from '../const';
import { selectSection } from '../selectors/section';

function ensureTitle(section) {
    return dispatch => {
        if (section.course_title != null) {
            return Promise.resolve(section);
        }
        return httpGET(section.course)
            .then(json)
            .then(course => {
                section.course_title = course.title;
                return section;
            });
    };
}

export function fetchSection(id) {
    return (dispatch, getState) => {
        return httpGET(`/api/v3/section/${id}/`)
            .then(json)
            .then(section => {
                return dispatch(ensureTitle(section)).then(section => {
                    dispatch({
                        type: ACTIONS.SYNC_SECTION,
                        section: section,
                    });
                    return selectSection(getState(), id);
                });
            });
    };
}

export function fetchSectionByUrl(url) {
    return (dispatch, getState) => {
        return httpGET(url)
            .then(json)
            .then(section => {
                return dispatch(ensureTitle(section)).then(section => {
                    dispatch({
                        type: ACTIONS.SYNC_SECTION,
                        section: section,
                    });
                    return section;
                });
            });
    };
}

export function fetchSectionsForTerm({ sections }) {
    return dispatch => {
        return Promise.all(
            sections.map(url => dispatch(fetchSectionByUrl(url)))
        );
    };
}

export function getSection(id, force) {
    return (dispatch, getState) => {
        const section = selectSection(getState(), id);
        if (section && section.id) {
            return Promise.resolve(section);
        }

        if (!id) {
            throw new Error('Missing ID?');
        }
        return dispatch(fetchSection(id));
    };
}



// WEBPACK FOOTER //
// ./src/actions/section.js